import React from "react";
import { get, useFormContext } from "react-hook-form";
import { Input, Alert } from "@material-tailwind/react";

// forwardRef merges RHF's register ref and a parent-forwarded ref onto the
// single inputRef, so a caller's focus effect reaches the real <input>.
const RHFInputIcon = React.forwardRef(function RHFInputIcon(
    { iconName, color = "black", ...props },
    ref
) {
    const { register, formState: { errors } } = useFormContext();
    const { ref: rhfRef, ...rest } = register(props.name);
    const error = get(errors, props.name);

    return (
        <>
            <Input
                {...rest}
                {...props}
                inputRef={(el) => {
                    rhfRef(el);
                    if (typeof ref === "function") {
                        ref(el);
                    } else if (ref) {
                        ref.current = el;
                    }
                }}
                color={color} // label, underline, text
                icon={
                    <span className="material-icons text-black text-base leading-none align-middle">
                        {iconName}
                    </span>
                }
                error={!!error}
                // Deliberately placed after {...props}: the hardcoded
                // classes always win over call-site props, so a call-site
                // className (e.g. the login password field's) never
                // reaches the input. Keeping the ordering keeps the
                // rendered DOM identical.
                className={`!text-black placeholder:!text-black`}
                labelProps={{
                    className: `!text-black peer-placeholder-shown:!text-black peer-focus:!text-black max-w-full truncate`,
                }}
            />
            {error && (
                <Alert color="red" className="mt-1 rounded-lg py-1 pl-5">
                    {error.message}
                </Alert>
            )}
        </>
    );
});

export default RHFInputIcon;
